import styled from 'styled-components';

const GridRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default GridRow;
